import React, { useState, useEffect } from 'react';
import PaceCalculator from './components/PaceCalculator';
import './App.css';

function App() {
  // Theme state
  const [theme, setTheme] = useState(() => {
    // Try to load from localStorage, default to 'dark'
    return localStorage.getItem('theme') || 'dark';
  });

  useEffect(() => {
    localStorage.setItem('theme', theme);
  }, [theme]);

  return (
    <div className={`App ${theme}-mode`}>
      <div className="theme-toggle">
        <label className="switch">
          <input
            type="checkbox"
            checked={theme === 'light'}
            onChange={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
          />
          <span className="slider"></span>
        </label>
        <span className="toggle-label">{theme === 'dark' ? '🌙' : '🌞'}</span>
      </div>
      <header className="App-header">
      </header>
      <main>
        <PaceCalculator />
      </main>
    </div>
  );
}

export default App;
